// components/AIChatbot/TypingIndicator.js

import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { tokens } from "../../theme/tokens";

const useStyles = makeStyles(() => ({
  typingContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "14px",
  },
  typingBubble: {
    backgroundColor: tokens.color.surface.sunken,
    borderRadius: "14px",
    borderBottomLeftRadius: "4px",
    padding: "10px 14px",
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  dot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    backgroundColor: tokens.color.text.secondary,
    animation: "$bounce 1.4s infinite ease-in-out",
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },
  dot1: {
    animationDelay: "0s",
  },
  dot2: {
    animationDelay: "0.2s",
  },
  dot3: {
    animationDelay: "0.4s",
  },
  "@keyframes bounce": {
    "0%, 80%, 100%": {
      transform: "scale(0)",
    },
    "40%": {
      transform: "scale(1)",
    },
  },
}));

/**
 * Typing Indicator Component
 * Shows animated dots when AI is processing
 */
const TypingIndicator = () => {
  const classes = useStyles();

  return (
    <Box className={classes.typingContainer}>
      <Box className={classes.typingBubble}>
        <Box className={`${classes.dot} ${classes.dot1}`} />
        <Box className={`${classes.dot} ${classes.dot2}`} />
        <Box className={`${classes.dot} ${classes.dot3}`} />
      </Box>
    </Box>
  );
};

export default TypingIndicator;
